// Table of contents scrollspy: marks the .toc link of the heading being read.

const BAND = '-96px 0px -68% 0px';
const PASSED_ABOVE_PX = 120;

export function initScrollspy(): void {
    const links = [...document.querySelectorAll<HTMLAnchorElement>('.toc a[href^="#"]')];

    if (!links.length) {
        return;
    }

    const byId = new Map(links.map((link) => [decodeURIComponent(link.hash.slice(1)), link]));
    const headings = [...byId.keys()]
        .map((id) => document.getElementById(id))
        .filter((heading): heading is HTMLElement => heading !== null);
    const visible = new Set<string>();

    const mark = (): void => {
        const current =
            headings.find((heading) => visible.has(heading.id)) ??
            // Nothing in the band? Fall back to the last heading scrolled past.
            [...headings].reverse().find((heading) => heading.getBoundingClientRect().top < PASSED_ABOVE_PX);

        links.forEach((link) => link.removeAttribute('aria-current'));

        if (current) {
            byId.get(current.id)?.setAttribute('aria-current', 'true');
        }
    };

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    visible.add(entry.target.id);
                } else {
                    visible.delete(entry.target.id);
                }
            });
            mark();
        },
        { rootMargin: BAND },
    );

    headings.forEach((heading) => observer.observe(heading));
    mark();
}
